var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRomance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.62 18.46c-4.3-2.58-9.51-.4-11.68 3.23-4.41 7.37 3.9 20.55 4.14 20.68",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6 24.44c4.29 2.57 4.83 8.2 2.65 11.82-4.41 7.35-19.96 6.23-20.17 6.1m11.19-18.68a7.64 7.64 0 0 0-3.65-5.22m3.65 5.22a7.54 7.54 0 0 1 6.33.76m-11.93-6.81a8.8 8.8 0 0 0 .43-5.12c-.89-3.64-4.7-6.85-9-5.81a6.73 6.73 0 0 0-4.47 3.44 6.7 6.7 0 0 0-5.55-1.01c-4.3 1.04-6.26 5.62-5.37 9.26 1.32 5.46 8.98 8.6 13 9.86",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomance);
export default __webpack_public_path__ + "static/media/romance.cbf13b0c7f0403c4723afd43c4264361.svg";
export { ForwardRef as ReactComponent };